/**
 * @generated SignedSource<<15a427c2342b31b6b22045151fd2394a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BillingTable_tenant$data = {
  readonly externalIncentivePerParticipantCostUsdCents: number;
  readonly panelistBonuses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly created: any;
        readonly givePointsPayment: {
          readonly pointsCost: string;
          readonly pointsFees: string;
        } | null;
        readonly id: string;
        readonly incentivePoints: number;
        readonly panelist: {
          readonly person: {
            readonly firstName: string | null;
            readonly lastName: string | null;
          } | null;
        } | null;
      } | null;
    } | null>;
  } | null;
  readonly requireStudyPayment: boolean;
  readonly " $fragmentType": "BillingTable_tenant";
};
export type BillingTable_tenant$key = {
  readonly " $data"?: BillingTable_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingTable_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "placedRange"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingTable_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requireStudyPayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalIncentivePerParticipantCostUsdCents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "placedRange",
          "variableName": "placedRange"
        }
      ],
      "concreteType": "PanelistBonusOrderConnection",
      "kind": "LinkedField",
      "name": "panelistBonuses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PanelistBonusOrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PanelistBonusOrderNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "created",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incentivePoints",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GivePointsPaymentNode",
                  "kind": "LinkedField",
                  "name": "givePointsPayment",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pointsCost",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pointsFees",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PanelistNode",
                  "kind": "LinkedField",
                  "name": "panelist",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PersonNode",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "af3abe12abfc9407319813abed9e8f30";

export default node;
